module.exports = __webpack_public_path__ + "static/headshot-ellie-c6bb8c4a10ad13cd03cb18c6fae9d78b.avif";